import { Box, Typography } from '@mui/material';
import { firebaseTimestampToDate } from '../../../firebase/firebase.utils';

import AuthorAvatar from '../../shared/author-avatar/author-avatar.component';

import { useWorkStyles } from './work-details.styles';

const WorkDetails = ({ work }) => {
  const classes = useWorkStyles();

  return (
    <Box display='flex' flexDirection='column'>
      <Typography
        component='h2'
        variant='h2'
        className={classes.wTitle}
        gutterBottom
      >
        {work.title}
      </Typography>
      <AuthorAvatar
        author={work.authorName}
        date={firebaseTimestampToDate(work.createdOn)}
        icon='video'
      />
      <Typography className={classes.wDescription}>
        {work.description}
      </Typography>
    </Box>
  );
};

export default WorkDetails;
